/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-plantlife/menu-header-plantlife-one-column-empty/menu-header-plantlife-one-column-empty.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.print-menu.plantlife-one-column-theme {
  page: plantlife-one-column-theme-pages;
}
@page plantlife-one-column-theme-pages {
  margin: 0.25in;
}
.plantlife-one-column-theme {
  --badge-grid-min-col: 1.1rem;
}
.plantlife-one-column-theme .header-container-wrapper {
  color: #98cc5c;
}
.plantlife-one-column-theme .header-container {
  flex-direction: row;
  justify-content: space-between;
  min-height: 1rem;
  padding-left: 0.7272727273rem;
  padding-right: 0.7272727273rem;
  padding-bottom: 0;
  height: 6.8181818182rem;
}
.plantlife-one-column-theme .header-container .company-logo {
  height: unset;
  max-width: 12.72rem;
  align-self: flex-end;
  margin-bottom: 0.9090909091rem;
  margin-left: 0.7272727273rem;
}
.plantlife-one-column-theme .main-header {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 4.1818181818rem;
  text-align: end;
  min-width: 1rem;
  margin-right: 0.3636363636rem;
}
.plantlife-one-column-theme .section-header-bottom-border {
  border-bottom: 1px solid;
}
.plantlife-one-column-theme .sections-container {
  border-top-width: 0;
  margin-left: 0;
  margin-right: 0;
  padding: 0;
}
.plantlife-one-column-theme .section-container {
  margin-left: 0.7272727273rem;
  margin-right: 0.7272727273rem;
}
.plantlife-one-column-theme .title-section {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 4.1rem;
  color: #98cc5c;
  height: 4.3636363636rem;
  box-sizing: border-box;
  padding: 0 1.0909090909rem 0.3636363636rem 1.0909090909rem;
}
.plantlife-one-column-theme .section-header-container {
  background-color: #98cc5c;
  color: #ffffff;
  border-color: #222222;
  height: 2.2727272727rem;
}
.plantlife-one-column-theme .section-title,
.plantlife-one-column-theme .section-header-general {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.3636363636rem;
  letter-spacing: -0.15px;
  text-transform: uppercase;
  text-align: center;
  padding: 0.3rem;
  height: 2.3rem;
}
.plantlife-one-column-theme .section-header-general {
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  box-sizing: border-box;
}
.plantlife-one-column-theme .product-container {
  border-bottom: 1px solid #222222;
  height: 4.3636363636rem;
  box-sizing: border-box;
}
.plantlife-one-column-theme .product-title-container.first-column {
  padding-left: 0.3rem;
}
.plantlife-one-column-theme .product-title-flex-container {
  gap: 0.3rem;
}
.plantlife-one-column-theme .product-title {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.6rem;
}
.plantlife-one-column-theme .product-badge {
  gap: 0.3rem;
}
.plantlife-one-column-theme .product-subtitle {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.4rem;
}
.plantlife-one-column-theme .product-column-general {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.4rem;
}
.plantlife-one-column-theme .footer-container {
  background: transparent;
  background-color: unset !important;
}
.plantlife-one-column-theme .product-strain-type {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: 0.76rem;
  padding-right: 0.76rem;
  width: fit-content;
  height: 2.1rem;
  color: #ffffff;
}
.plantlife-one-column-theme .product-strain-type.i,
.plantlife-one-column-theme .product-strain-type.indica {
  background-color: #7663e3;
  border: 1px solid #7663e3;
}
.plantlife-one-column-theme .product-strain-type.s,
.plantlife-one-column-theme .product-strain-type.sativa {
  background-color: #f0a005;
  border: 1px solid #f0a005;
}
.plantlife-one-column-theme .product-strain-type.h,
.plantlife-one-column-theme .product-strain-type.hybrid {
  background-color: #77d11f;
  border: 1px solid #77d11f;
}
.plantlife-one-column-theme .product-strain-type.b,
.plantlife-one-column-theme .product-strain-type.blend {
  background-color: #5690f0;
  border: 1px solid #5690f0;
}
.plantlife-one-column-theme .product-strain-type.c,
.plantlife-one-column-theme .product-strain-type.cbd {
  background-color: #b8b8b8;
  border: 1px solid #b8b8b8;
}
.plantlife-one-column-theme .product-label {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.9rem;
  height: 1rem;
  border-radius: 0.2rem;
  letter-spacing: 0.01rem;
}
.plantlife-one-column-theme .badge {
  height: 1.1rem;
}
.plantlife-one-column-theme .badge-within-badge-column {
  height: 2.1818181818rem;
}
.plantlife-one-column-theme .empty-container {
  background-color: #ffffff;
  margin-left: 0.7272727273rem;
  margin-right: 0.7272727273rem;
}
.plantlife-one-column-theme .image-section {
  margin-top: 0;
}
.plantlife-one-column-theme .force-bold-style * {
  font-family: bebas-neue-pro, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.plantlife-one-column-empty-header {
  height: 1rem;
  background-color: #222222;
}
/*# sourceMappingURL=menu-header-plantlife-one-column-empty.component.css.map */
